import { useEffect } from 'react'
import { TextField, Grid, MenuItem } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useController } from 'react-hook-form'
import PhoneField from 'components/PhoneField'

export default function PhoneEditForm({ path, control, item, index }) {
  const { t } = useTranslation()
  const isPrimary = index === 0
  const { field, fieldState } = useController({ name: `${path}.${index}.type`, control })
  const { value, onChange } = field

  useEffect(() => {
    if (isPrimary && value !== 'mobile') onChange('mobile')
  }, [isPrimary, value, onChange])

  return (
    <Grid item xs={12} md={12} key={item?.id}>
      <Grid container spacing={2}>
        <Grid item xs={3} md={3}>
          <TextField
            fullWidth
            select
            size="small"
            label={t('Type')}
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
            {...field}
            disabled={isPrimary}
          >
            <MenuItem value="home">{t('Home')}</MenuItem>
            <MenuItem value="mobile">{t('Mobile')}</MenuItem>
            <MenuItem value="work">{t('Work')}</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={9} md={9}>
          <PhoneField
            name={`${path}.${index}.number`}
            control={control}
            label={index > 0 ? t('Alternate Number') : t('Primary Number')}
            size="small"
          />
        </Grid>
      </Grid>
    </Grid>
  )
}
